import { useTranslation } from "react-i18next";
import styles from "./InviteUserTab.module.css";
import Button from "../../UI/Button/Button";

export default function InviteUserTab({
  inviteEmail,
  setInviteEmail,
  isInviting,
  handleInviteUser,
}) {
  const { t } = useTranslation("common");

  return (
    <div className={styles.tabContent}>
      <div className={styles.sectionHeader}>
        <div>
          <h2 className={styles.sectionTitle}>
            {t("userInfoPage.inviteUser.title")}
          </h2>
          <p className={styles.sectionDescription}>
            {t("userInfoPage.inviteUser.description")}
          </p>
        </div>
      </div>

      <div className={styles.inviteForm}>
        <form onSubmit={handleInviteUser}>
          <div className={styles.inputGroup}>
            <label htmlFor="inviteEmail" className={styles.inputLabel}>
              {t("userInfoPage.inviteUser.emailLabel")}
            </label>
            <input
              type="email"
              id="inviteEmail"
              value={inviteEmail}
              onChange={(e) => setInviteEmail(e.target.value)}
              placeholder={t("userInfoPage.inviteUser.emailPlaceholder")}
              className={styles.emailInput}
              required
            />
          </div>
          <Button
            type="submit"
            disabled={isInviting || !inviteEmail.trim()}
          >
            {isInviting
              ? t("userInfoPage.inviteUser.sending")
              : t("userInfoPage.inviteUser.sendInvitation")}
          </Button>
        </form>
      </div>
    </div>
  );
}
